'use strict';

var $ = require('jquery');
require('waypoints/lib/jquery.waypoints.js');

var SELECTORS = {
    PRODUCTIONHEADER: '.js-production-header-mini',
    TRIGGER: '.js-production-waypoint'
};

function stickyProgress(elem) {
    var productionHeader = $(SELECTORS.PRODUCTIONHEADER);
    elem.waypoint({
        handler: function() {
            productionHeader.toggleClass('is-visible');
        }
    });
}

function init() {
    var trigger = $(SELECTORS.TRIGGER);

    if (trigger) {
        stickyProgress(trigger);
    }
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/productionHeader.js